/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { PaycardTypeDto } from './paycardTypeDto.schema';

export const IReadOnlyListOfPaycardTypeDto = zod.array(zod.lazy(() => PaycardTypeDto));

export type IReadOnlyListOfPaycardTypeDto = zod.input<typeof IReadOnlyListOfPaycardTypeDto>;
export type IReadOnlyListOfPaycardTypeDtoOutput = zod.output<typeof IReadOnlyListOfPaycardTypeDto>;
